import { Component, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep } from '../../../core/models/notification.model';

@Component({
  selector: 'wf-post-assessment-reminder-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="🏆 Students are almost at the finish line!"
      [preambles]="[
        {
          text: 'The student(s) below completed are beginning Unit 24 — the last instructional unit in WordFlight. '
            + 'Kudos! At the end of Unit 24, they’ll complete the Objective 6 Posttest and then take their final Diagnostic. '
            + 'This is the last major milestone and your best look at how far they’ve come.'
        },
        {
          text: 'In the next two weeks, help set your student up for success:',
          isSubheading: true,
        }
      ]"
      [steps]="steps"
      ctaLabel="Open Diagnostic Results"
      ctaRoute="/reports/system/diagnostic"
      closingText="You’re doing great work — good luck to you and your student(s)!"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true
})
export class PostAssessmentReminderNotificationComponent {
  readonly data = input.required<any>();
  readonly steps: NotificationStep[] = [
    {
      title: 'Give them a heads up',
      body: 'Let them know an important Diagnostic is coming. It spans several sessions, so encourage them to bring their '
        + 'best effort each time — there’s no right/wrong feedback during the Diagnostic.'
    },
    {
      title: 'Build excitement for the home stretch',
      body: 'Extra points are available during the Diagnostic. Let them know you’ll review the results together — it’s a chance to see everything they’ve accomplished.',
    },
    {
      title: 'Track their progress',
      body: 'Open the Diagnostic Results report anytime to check their progress percentage. You’ll get a notification when they complete the Diagnostic.',
      variant: 'green',
    }
  ];
}
